const state = {
  showCajaModal: false,
  modalType: null,
};
const getters = {
  cajaModal: state => state.showCajaModal,
  cajaModalType: state => state.modalType,
};
const actions = {
  toggleCajaModal: ({commit}, payload)=>{
    commit('setCajaModalShowState', payload);
  },
  openCajaModal: ({commit}, payload)=>{
    // console.log("[openCajaModal|payload] ", payload);
    commit('setCajaModalShowState', true);
    commit('setCajaModalType', payload)
  },
  closeCajaModal: ({commit})=>{
    commit('setCajaModalShowState', false);
  },
};
const mutations = {
  setCajaModalShowState: (state, payload) => state.showCajaModal = payload,
  setCajaModalType: (state, payload) => state.modalType = payload,
};


export default {
  state,
  getters,
  mutations,
  actions
};